module.exports = __webpack_public_path__ + "assets/img/bb99ca9e0b44138139f093adbc52280e.png";